/* Copyright (c) 2021-2026, NVIDIA CORPORATION.  All rights reserved.
 *
 * NVIDIA CORPORATION and its licensors retain all intellectual property
 * and proprietary rights in and to this software, related documentation
 * and any modifications thereto.  Any use, reproduction, disclosure or
 * distribution of this software and related documentation without an express
 * license agreement from NVIDIA CORPORATION is strictly prohibited.
 */

import { Component, Input } from '@angular/core';

import { MatCard, MatCardContent } from '@angular/material/card';
import { MatDivider } from '@angular/material/divider';
import { MatButton } from '@angular/material/button';
import { FlexModule } from '@angular/flex-layout/flex';

import { Topic, Configuration } from '../shared';

@Component({
    selector: 'nv-learn-article',
    imports: [FlexModule, MatButton, MatCard, MatCardContent, MatDivider],
    templateUrl: './learn-article.component.html',
    styleUrl: './learn-article.component.scss'
})
export class LearnArticleComponent {
    @Input() topics: Topic[] = [];

    constructor(private appConfig: Configuration) {}

    public getTopicPath(topic: Topic): string {
        return `${this.appConfig.vdkPlaytestConfig.publicLearnArticlesBaseUrl}/${topic.path}`;
    }

    public getTopicImagePath(topic: Topic): string {
        return `${this.appConfig.vdkPlaytestConfig.publicLearnImagesBaseUrl}/${topic.imagePath}`;
    }
}
